import { useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

/**
 * Confirmación previa a una acción que cambia el acceso (activar/desactivar).
 * Cancelar no dispara ninguna mutación; confirmar dispara exactamente una.
 */
export default function ConfirmAccion({ open, onOpenChange, titulo, texto, nota,
  confirmLabel, onConfirm, testPrefix }) {
  const [enviando, setEnviando] = useState(false);

  const confirmar = async () => {
    if (enviando) return;
    setEnviando(true);
    try { await onConfirm(); } finally { setEnviando(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!enviando) onOpenChange(v); }}>
      <DialogContent className="w-[calc(100%-2rem)] max-w-md rounded-2xl max-h-[85vh] overflow-y-auto"
        data-testid={`${testPrefix}-confirm-dialog`}>
        <DialogHeader>
          <DialogTitle className="text-[#012472] break-words">{titulo}</DialogTitle>
          <DialogDescription className="text-sm text-slate-600">{texto}</DialogDescription>
        </DialogHeader>
        {nota && <p className="text-xs text-slate-500">{nota}</p>}
        <DialogFooter className="gap-2">
          <Button variant="outline" className="rounded-xl w-full sm:w-auto" disabled={enviando}
            data-testid={`${testPrefix}-confirm-cancelar`} onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button className="rounded-xl w-full sm:w-auto bg-[#012472] hover:bg-[#011c5a] text-white"
            disabled={enviando} data-testid={`${testPrefix}-confirm-aceptar`} onClick={confirmar}>
            {enviando ? "Aplicando…" : confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
